module.exports = {"actions":{"edit":"Bewerken","delete":"Verwijderen","save":"Opslaan","cancel":"Annuleren","back":"Terug","print":"Afdrukken","download":"Downloaden"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/common.json
// module id = UA15
// module chunks = 15